/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedUncancelledInProgramCallsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedUncancelledInProgramCallsQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    inProgramVideoCallBookingInformation?: {
      __typename?: 'InProgramVideoCallBookingInformation'
      uncancelledCalls: Array<{
        __typename?: 'VideoCall'
        id: string
        startTime: Date
        endTime: Date
        checkInCallPatientHistoryEntryID?: string | null
      }>
    } | null
  }
}

export const GetAdvancedUncancelledInProgramCallsDocument = gql`
  query getAdvancedUncancelledInProgramCalls($uid: ID!) {
    patient(uid: $uid) {
      inProgramVideoCallBookingInformation {
        uncancelledCalls {
          id
          startTime
          endTime
          checkInCallPatientHistoryEntryID
        }
      }
    }
  }
`

/**
 * __useGetAdvancedUncancelledInProgramCallsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedUncancelledInProgramCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedUncancelledInProgramCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedUncancelledInProgramCallsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedUncancelledInProgramCallsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedUncancelledInProgramCallsQuery,
    GetAdvancedUncancelledInProgramCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedUncancelledInProgramCallsQuery, GetAdvancedUncancelledInProgramCallsQueryVariables>(
    GetAdvancedUncancelledInProgramCallsDocument,
    options
  )
}
export function useGetAdvancedUncancelledInProgramCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedUncancelledInProgramCallsQuery,
    GetAdvancedUncancelledInProgramCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdvancedUncancelledInProgramCallsQuery,
    GetAdvancedUncancelledInProgramCallsQueryVariables
  >(GetAdvancedUncancelledInProgramCallsDocument, options)
}
export type GetAdvancedUncancelledInProgramCallsQueryHookResult = ReturnType<
  typeof useGetAdvancedUncancelledInProgramCallsQuery
>
export type GetAdvancedUncancelledInProgramCallsLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedUncancelledInProgramCallsLazyQuery
>
export type GetAdvancedUncancelledInProgramCallsQueryResult = Apollo.QueryResult<
  GetAdvancedUncancelledInProgramCallsQuery,
  GetAdvancedUncancelledInProgramCallsQueryVariables
>
